import React from 'react';

import useSeo from 'coreHooks/useSeo';

import Canonical from './Subcomponents/Canonical';
import HrefLangs from './Subcomponents/HrefLangs';
import JsonLd from './Subcomponents/JsonLd';
import Links from './Subcomponents/Links';
import MetaData from './Subcomponents/MetaData';

const SEO = () => {
	const seo = useSeo();

	return <>
		<MetaData metadata={seo.getMetadata()} />
		<HrefLangs urls={seo.getPageUrls()} />
		<JsonLd jsonLd={seo.getJsonLd()} />
		<Links links={seo.getLinks()} />
		<Canonical href={seo.getCanonicalURL()} />
	</>;
};

export default SEO;
